import PropTypes from 'prop-types';
export const authorPropTypes = {
  /**
   * Author's page URL
   */
  href: PropTypes.string,
  /**
   * Author's picture: src and alt
   */
  picture: PropTypes.exact({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  /**
   * Author's title
   */
  title: PropTypes.string,
  /**
   * Author's name
   */
  name: PropTypes.string.isRequired,
  /**
   * Author's role
   */
  role: PropTypes.string
};